import { SerializedMeter } from '@enmon/commons/lib/enmon';
import { Moment } from 'moment';
import type { RegisterState, ReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { SetState } from 'zustand';

export interface OldValuesStepForm {
  replacementDate?: Moment;
  oldSerialNumber?: SerializedMeter['serial'];
  oldRegisterStates?: RegisterState[];
}

const INITIAL_STATE: OldValuesStepForm = {
  replacementDate: undefined,
  oldSerialNumber: undefined,
  oldRegisterStates: [],
};

export interface OldValuesStepSlice extends OldValuesStepForm {
  setOldValuesStepValues: (values: OldValuesStepForm) => void;
  resetOldValuesStepSlice: (initValues?: Partial<OldValuesStepForm>) => void;
}

export const createOldValuesStepSlice = (set: SetState<ReplaceMeterStore>): OldValuesStepSlice => ({
  ...INITIAL_STATE,
  setOldValuesStepValues: (values: OldValuesStepForm) => set(values),
  resetOldValuesStepSlice: (initValues = {}) => set({ ...INITIAL_STATE, ...initValues }),
});
